module.exports = __webpack_public_path__ + "img/policy_menu.230f8f6a.svg";